import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Forms from './forms';
import './preflight.css';
import '../../globals.css';
import '../../form.css';

export default () => {
  return (
    <Switch>
      <Route path="/forms" component={Forms} />
    </Switch>
  );
};
